// extracted by mini-css-extract-plugin
export default {"mark__button__style":"CircleButtonMark_mark__button__style__30GTY"};